import { combineReducers } from 'redux'

import auth from '@/containers/Login/AuthSlice'
import pageConfiguration from '@/store/PageConfiguration/PageConfigurationSlice'
import usersManagement from '@/containers/UsersManagement/UsersManagementSlice'
import servicesStatus from '@/containers/ServicesStatus/ServicesStatusSlice'
import carbonOffsets from '@/containers/CarbonOffsetManagement/CarbonOffsetsSlice'
import officesManagement from '@/containers/OfficesManagement/OfficesManagementSlice'
import teamsManagement from '@/containers/TeamsManagement/TeamsManagementSlice'
import suppliersManagement from '@/containers/SuppliersManagement/SuppliersManagementSlice'
import italyFiscalCodesManagement from '@/containers/ItalyFiscalCodesManagement/italyFiscalCodesManagementSlice'
import websalesUsersManagement from '@/containers/WebsalesUsersManagement/WebsalesUsersManagementSlice'
import assistanceProducts from '@/containers/AssistanceProductsManagement/AssistanceSlice'
import monConseillerPersoProducts from '@/containers/MonConseillerPersoProductsManagement/MonConseillerPersoSlice'
import dashboard from '@/containers/DashboardPageV2/DashboardSlice'
import formV2 from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import clientCallbacks from '@/containers/ClientCallbacksPage/ClientCallbacksSlice'
import breakManagement from '@/containers/BreakManagementPage/breakManagementSlice'
import additionalProductsTools from '@/containers/AdditionalSalesManagement/additionalProductsToolsSlice'
import searchContacts from '@/containers/ContactSearchPage/searchContactsSlice'
import contactsTools from '@/containers/DevToolsNew/Contacts/contactsSlice'
import podUpdaterTools from '@/containers/DevToolsNew/PodUpdater/podUpdaterSlice'
import commandsTools from '@/containers/DevToolsNew/Commands/commandsSlice'
import communicationBoardTools from '@/containers/DevToolsNew/CommunicationBoard/communicationBoardSlice'
import communicationBoardPollResults from '@/containers/DevToolsNew/CommunicationBoard/PollResults/pollResultsSlice'
import communicationBoardPolls from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/BoardPoll/boardPollsSlice'
import cacheTools from '@/containers/DevToolsNew/Cache/cacheSlice'
import betaFeaturesTools from '@/containers/DevToolsNew/BetaFeatures/betaFeaturesSlice'
import nettingUpdaterTools from '@/containers/OrganizationsManagement/NettingUpdater/nettingUpdaterSlice'
import organizationsManagement from '@/containers/OrganizationsManagement/organizationsManagementSlice'
import dashboardV2 from '@/containers/DashboardPageV2/DashboardV2Slice'
import home from '@/containers/HomePage/HomeSlice'
import hopTimus from '@/hoc/HopTimusButton/hopTimusSlice'

const appReducer = combineReducers({
  auth,
  pageConfiguration,
  usersManagement,
  servicesStatus,
  carbonOffsets,
  officesManagement,
  teamsManagement,
  suppliersManagement,
  italyFiscalCodesManagement,
  websalesUsersManagement,
  assistanceProducts,
  monConseillerPersoProducts,
  dashboard,
  formV2,
  clientCallbacks,
  breakManagement,
  additionalProductsTools,
  contactsTools,
  podUpdaterTools,
  commandsTools,
  communicationBoardTools,
  communicationBoardPollResults,
  communicationBoardPolls,
  cacheTools,
  betaFeaturesTools,
  nettingUpdaterTools,
  organizationsManagement,
  searchContacts,
  dashboardV2,
  home,
  hopTimus,
})

export type RootState = ReturnType<typeof appReducer>

export const rootReducer = (state: ReturnType<typeof appReducer>, action: any) => appReducer(state, action)
